// extracted by mini-css-extract-plugin
export default {"body":"BlockContactModal_body__QX-zm"};